import { render, staticRenderFns } from "./OpenAIList.vue?vue&type=template&id=5df3f64c&"
import script from "./OpenAIList.vue?vue&type=script&lang=js&"
export * from "./OpenAIList.vue?vue&type=script&lang=js&"
import style0 from "./OpenAIList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports